import cx from 'classnames';
import {
    FGTypography,
    FGButton,
    FGTooltip,
    TOOLTIP_PLACEMENT,
} from '@fg/design-system';

export interface Props {
    title: string;
    tooltip: string;
    iconComponent?: JSX.Element;
    svgIcon?: any;
    onClick: () => any;
    disabled: boolean;
    active: boolean;
}

const DATA_TYPE_TOGGLE_CLASSNAME = 'timeline-toggle-data-type';
const ACTIVE_CLASSNAME = 'active';
const DISABLED_CLASSNAME = 'disabled';

const DataTypeToggle = (props: Props) => {
    return (
        <FGTooltip
            className="timeline-tooltip"
            appendTo="parent"
            placement={TOOLTIP_PLACEMENT.top}
            content={
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        textAlign: 'center',
                    }}>
                    {props.tooltip}
                </div>
            }>
            {/* div wrapper needed so tooltip hover works */}
            <div>
                <FGButton
                    {...(props.iconComponent
                        ? { icon: props.iconComponent }
                        : {})}
                    onClick={props.onClick}
                    className={cx(
                        DATA_TYPE_TOGGLE_CLASSNAME,
                        props.active && ACTIVE_CLASSNAME,
                        props.disabled && DISABLED_CLASSNAME
                    )}
                    disabled={props.disabled}>
                    <FGTypography tag="label" variant="label2">
                        {props.title}
                    </FGTypography>
                </FGButton>
            </div>
        </FGTooltip>
    );
};

export default DataTypeToggle;
